/* eslint-disable */
import { produce } from "immer";
import {
  UPLOAD_DOC_PATCH_START,
  UPLOAD_DOC_PATCH_SUCCESS,
  UPLOAD_DOC_PATCH_FAILURE,
} from "../actions/types";

const uploadDoc = (
  state = {
    uploadDocFetching: false,
    uploadDocData: {},
    uploadDocError: null,
  },
  action,
) => {
  switch (action.type) {
    case UPLOAD_DOC_PATCH_START:
      return produce(state, (draft) => {
        draft.uploadDocFetching = true;
      });
    case UPLOAD_DOC_PATCH_SUCCESS:
      return produce(state, (draft) => {
        draft.uploadDocFetching = true;
        draft.uploadDocData = action.data;
        draft.uploadDocFetching = false;
      });
    case UPLOAD_DOC_PATCH_FAILURE:
      return produce(state, (draft) => {
        draft.uploadDocFetching = false;
        draft.uploadDocError = action.error;
      });
    default:
      return state;
  }
};

export default uploadDoc;
